import { mapActions, mapGetters } from 'vuex';
import { CMS_CONTRACT_CLICK_OPEN_ORDERSLIP, CMS_MARKET_RUNTIME } from '@/components/cms/cms-config';
import marketContractHorizontalSushiMobile from '@/components/market/market-contract-horizontal-sushi-common-betslip/market-contract-horizontal-sushi-common-betslip.vue';
import marketContractHorizontalSushi from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi.vue';
import marketContractsListHeaderSushi from '@/components/market/market-contracts-list-header-sushi/market-contracts-list-header-sushi.vue';
import { pushStoryInteraction, INTERACTION_TYPE } from '@/helpers/dataLayer';
import { isWrapperApp } from '@/mixins/userAgent';

const NARROW_CONTAINER_WIDTH = 900;

export default {
  inject: { cmsRuntime: { from: CMS_MARKET_RUNTIME, default: null } },
  props: {
    openNewTab: {
      type: Boolean,
      default: false,
    },
    market: {
      type: Object,
      required: true,
    },
    trackingContext: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isNarrowContainer: false,
      containerResizeObserver: null,
    };
  },
  components: {
    marketContractHorizontalSushi,
    marketContractHorizontalSushiMobile,
    marketContractsListHeaderSushi,
  },
  computed: {
    displayMarket() {
      return this.cmsRuntime?.markets[this.market.marketId] || this.market;
    },
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    ...mapGetters('user', ['isLoggedIn']),
  },
  watch: {
    market: {
      immediate: true,
      handler(market) {
        this.cmsRuntime?.seed([market]);
      },
    },
  },
  methods: {
    isCmsTradeDisabled(contract) {
      return (
        CMS_CONTRACT_CLICK_OPEN_ORDERSLIP &&
        !!this.cmsRuntime &&
        !this.cmsRuntime.canTrade(this.displayMarket, contract)
      );
    },
    captureTrigger(event) {
      this.orderTrigger = event.target.closest('button');
    },
    ...mapActions('onboarding', ['showOnboardingStep']),
    updateContainerLayoutMode() {
      const containerWidth = this.$el ? this.$el.clientWidth : 0;
      this.isNarrowContainer = containerWidth > 0 && containerWidth < NARROW_CONTAINER_WIDTH;
    },
    teardownResizeObserver() {
      if (this.containerResizeObserver) {
        this.containerResizeObserver.disconnect();
        this.containerResizeObserver = null;
      }
    },
    setupResizeObserver() {
      this.teardownResizeObserver();
      this.updateContainerLayoutMode();
      if (typeof ResizeObserver === 'undefined' || !this.$el) {
        return;
      }
      this.containerResizeObserver = new ResizeObserver(() => {
        this.updateContainerLayoutMode();
      });
      this.containerResizeObserver.observe(this.$el);
    },
    onContractClick(data) {
      if (
        CMS_CONTRACT_CLICK_OPEN_ORDERSLIP &&
        this.cmsRuntime &&
        this.orderTrigger &&
        ['yes', 'no'].includes(data.operationValue)
      ) {
        const contract = this.displayMarket.contracts.find(
          (item) => item.contractId === data.contractId,
        );
        if (!this.cmsRuntime.canTrade(this.displayMarket, contract)) return;
        this.cmsRuntime.seed([this.displayMarket]);
        this.cmsRuntime.openOrder({
          marketId: this.market.marketId,
          contractId: data.contractId,
          direction: data.operationValue,
          priceCents: data.priceCents,
          trigger: this.orderTrigger,
        });
        this.orderTrigger = null;
        return;
      }
      const { contractId, operationValue } = data;
      const no = operationValue === 'no' ? true : undefined;
      const route = {
        name: 'market-details',
        params: {
          marketId: this.market.marketId,
          marketUrl: this.market.marketUrl,
        },
        query: {
          contractId,
          no,
        },
      };
      pushStoryInteraction({
        interactionType: INTERACTION_TYPE.CONTRACT_CURRENT_PRICE_LIST,
        ...this.trackingContext,
      });
      if (!this.openNewTab || isWrapperApp) {
        this.$router.push(route);
      } else {
        const resolved = this.$router.resolve(route);
        window.open(resolved.href, '_blank');
      }
    },
  },
  mounted() {
    this.setupResizeObserver();
  },
  beforeUnmount() {
    this.teardownResizeObserver();
  },
};
